import React from 'react'
import { View } from '../../../../styles/reactnative'
import { PopUpInputSection, PopUpTitleSection, SaveBtn } from '../styles'
import PopUpModalHeader from '../PopupSetting/PopUpUpdate/PopUpModalHeader'
import { Button, Form, Space, Switch } from 'antd'
import SettingTitle from '../SettingTitle'
import SettingCheckBox from '../SettingCheckBox'
import SettingInput from '../SettingInput'
import TableAPI from '../../../components/TableAPI'
import { columns } from './columns'
import { SystemWrap } from './styles'

const ExChangeSetting = () => {
	const [type, setType] = React.useState('G')

	return (
		<SystemWrap>
			<TableAPI
				title={'시스템설정'}
				columns={columns}
				usermodal={false}
				height={'default'}
				apikey={`/admin/settings?type=${type}`}
				pagination={false}
				extra={
					<Switch
						checkedChildren="글로벌만"
						unCheckedChildren="전체보기"
						defaultChecked={type == 'G'}
						onChange={(checked, event) => {
							setType(checked ? 'G' : 'ALL')
						}}
					/>
				}
			/>
		</SystemWrap>
	)
}

export default React.memo(ExChangeSetting)
